export function SectionHeading({ eyebrow, title, description, align = "left", tone = "default" }) {
  const alignment = align === "center" ? "mx-auto text-center" : "text-left";
  const titleTone = tone === "light" ? "text-white" : "text-stone-900";
  const eyebrowTone = tone === "light" ? "bg-white/10 text-emerald-100" : "bg-primary/10 text-primary";
  const descriptionTone = tone === "light" ? "text-emerald-50" : "text-stone-600";

  return (
    <div className={`max-w-2xl ${alignment}`.trim()}>
      {eyebrow ? (
        <span className={`mb-3 inline-block rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-[0.24em] ${eyebrowTone}`}>
          {eyebrow}
        </span>
      ) : null}
      <h2 className={`font-heading text-4xl font-semibold tracking-tight sm:text-5xl ${titleTone}`}>
        {title}
      </h2>
      {description ? (
        <p className={`mt-4 text-sm leading-7 sm:text-base ${descriptionTone}`}>
          {description}
        </p>
      ) : null}
    </div>
  );
}